import React from 'react'
import { useTranslation } from 'react-i18next'
import { SidePanelSection } from 'components/SidePanel/SidePanelSection'
import { SidePanelRowProps, SidePanelSummary } from 'components/SidePanel/SidePanelSummary'
import { getCustomerAddress } from 'pages/Customers/helpers/utils'
import { EmbeddedBusinessCustomer, EmbeddedCustomerEntityDetailsProps } from '../helpers/types'

export const BusinessCustomer = ({
  customer: company,
  sharedCustomerDetails,
  sharedComplianceDetails,
}: EmbeddedCustomerEntityDetailsProps<EmbeddedBusinessCustomer>) => {
  const { t } = useTranslation()
  const { address, associates } = company || {}

  const customerDetailsRows: SidePanelRowProps[] = [
    ...sharedCustomerDetails,
    { label: t('businessName'), content: company?.name },
    { label: t('industry'), content: company?.industry?.name },
    { label: t('businessRegistrationNumber'), content: company?.registrationNumber },
    { label: t('taxResidencyCountry'), content: company?.taxResidenceCountryCode },
    { label: t('address'), content: getCustomerAddress(address, { usePostalCode: true }) },
    { label: t('country'), content: address?.country },
    ...sharedComplianceDetails,
  ]

  const associatesRows: SidePanelRowProps[] = associates?.map(({ person, title }) => ({
    label: title,
    content: `${person?.firstName} ${person?.lastName}`,
  }))

  return (
    <>
      <SidePanelSection heading={t('embeddedCustomers.details.customerDetails')}>
        <SidePanelSummary rows={customerDetailsRows} />
      </SidePanelSection>
      {associatesRows && (
        <SidePanelSection heading={t('associates.title')}>
          <SidePanelSummary rows={associatesRows} showEmpty />
        </SidePanelSection>
      )}
    </>
  )
}
